/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { getClientEmbedsData } from 'state/actions/embedsState/embeds_status';
// component
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols';



/* ========== ~~~~~~~~~~ EMBED CONTROLS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus, embedsState }) => ({
    accountUUID: sessionStatus.accountUUID,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
        dispatch(updateStepDetails(location));
        dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
    getClientEmbedsData: accountUUID => dispatch(getClientEmbedsData(accountUUID)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedControls);
